var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4418_8952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4 12.95L18.62 14.34C18.43 14.44 18.2 14.4 18.04 14.25L16.17 12.38C15.97 12.18 15.97 11.87 16.17 11.67L18.07 9.77002C18.22 9.62002 18.46 9.58002 18.65 9.68002L21.4 11.06C22.19 11.44 22.19 12.56 21.4 12.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 8.48948C16.61 8.63948 16.67 9.04949 16.43 9.28949L14.76 10.9595L14.05 11.6695C13.85 11.8695 13.54 11.8695 13.34 11.6695L6.19997 4.52948C5.79997 4.12948 6.26997 3.4795 6.77997 3.7295L16.3 8.48948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20.1491V3.47911C2 3.03911 2.53 2.80909 2.85 3.11909L11.62 11.6291C11.83 11.8291 11.82 12.1591 11.61 12.3591L2.84 20.5191C2.52 20.8191 2 20.5891 2 20.1491Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2701 15.5207L6.88007 20.2207C6.37007 20.4707 5.90007 19.8207 6.30007 19.4207L13.3501 12.3707C13.5501 12.1707 13.8601 12.1707 14.0601 12.3707L16.4101 14.7207C16.6401 14.9607 16.5701 15.3707 16.2701 15.5207Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4418_8952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.20420d4ae7700100ac8c7eb4c8f61776.svg";
export { ForwardRef as ReactComponent };